import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedPatientNavigatorConfiguration
} from "../App/Compositions/NavigatorConfigurations";
import {
  noConfirmationStaticCenterBookingStepConfigurations,
  screeningStepConfigurations
} from "../App/Compositions/StepConfigurations";
import { Flow } from "./IFlow";

const rebookFlowName = "rebook";

/** Legacy flow name alias. Routes users with cached "rebook" sessions to the no-confirmation experience. */
class RebookFlow extends Flow {
  static readonly flowName = rebookFlowName;

  constructor(isPatientPreQualified: boolean) {
    isPatientPreQualified
      ? super(rebookFlowName, { ...noConfirmationStaticCenterBookingStepConfigurations }, [
          ...NoConfirmationPreQualifiedPatientNavigatorConfiguration
        ])
      : super(
          rebookFlowName,
          { ...screeningStepConfigurations, ...noConfirmationStaticCenterBookingStepConfigurations },
          [...NoConfirmationDefaultNavigatorConfiguration]
        );
  }
}

export default RebookFlow;
